import { TokenExpired } from 'components/tokenExpired';
import { useCanAccess } from 'hooks/useCanAccess';
import { useGetUserCognitoGroup } from 'hooks/useGetUserCognitoGroup';
import { Dashboard } from 'pages/dashboard/dashboard';
import { ProviderDashboard } from 'pages/providerDashboard/ProviderDashboard';
import { useEffect, useState } from 'react';

export const DashboardManagementRoute = () => {
  const { isExpired } = useCanAccess('');
  const [role, setRole] = useState<string>('');

  const cognitoGroupRole = useGetUserCognitoGroup();
  useEffect(() => {
    setRole(cognitoGroupRole);
  }, [cognitoGroupRole]);

  if (isExpired) {
    return <TokenExpired />;
  }

  switch (role) {
    case 'ADMIN':
    case 'USER':
      return <Dashboard />;
    case 'PROVIDER':
      return <ProviderDashboard />;
    default:
      return null;
  }
};
